import { render, staticRenderFns } from "./ArrangeSection.vue?vue&type=template&id=17a1930b&"
import script from "./ArrangeSection.vue?vue&type=script&lang=js&"
export * from "./ArrangeSection.vue?vue&type=script&lang=js&"
import style0 from "./ArrangeSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports